// extracted by mini-css-extract-plugin
export var m_social_media_icons = "socialMediaIcons-module--m_social_media_icons--2b584";
export var m_social_media_icons__rrss = "socialMediaIcons-module--m_social_media_icons__rrss--9bccd";
export var m_social_media_icons__title = "socialMediaIcons-module--m_social_media_icons__title--3daf1";